document.addEventListener('DOMContentLoaded', () => {
  initCart();
});

document.addEventListener('shopify:section:load', () => {
  initCart();
});

function initCart() {
  const sectionsUrl = document.body.dataset.sectionsUrl || window.location.origin;
  const cartAddUrl = document.body.dataset.cartAddUrl || '/cart/add.js';
  const cartChangeUrl = document.body.dataset.cartChangeUrl || '/cart/change.js';
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  let cartDrawerBody = document.querySelector('[data-cart-drawer-body]');
  let cartDrawerFooter = document.querySelector('[data-cart-drawer-footer]');
  const cartCountEls = document.querySelectorAll('[data-cart-count]');
  const isCartPage = document.body.classList.contains('template-cart');

  const menuToggle = document.querySelector('[data-menu-toggle]');
  const siteNav = document.querySelector('[data-site-nav]');

  if (menuToggle && siteNav && !menuToggle.dataset.bound) {
    menuToggle.dataset.bound = 'true';
    menuToggle.addEventListener('click', () => {
      siteNav.classList.toggle('is-open');
    });
  }

  function updateCartCount(count) {
    cartCountEls.forEach((el) => {
      el.textContent = count;
      el.classList.toggle('cart-count--hidden', count === 0);
    });
  }

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
  }

  async function refreshCartDrawer() {
    if (!cartDrawerBody) return null;

    try {
      const response = await fetch(`${sectionsUrl}/?sections=cart-drawer`);
      if (!response.ok) return null;

      const data = await response.json();
      const html = data['cart-drawer'];
      if (!html) return null;

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newBody = doc.querySelector('[data-cart-drawer-body]');
      const newFooter = doc.querySelector('[data-cart-drawer-footer]');

      if (newBody) cartDrawerBody.innerHTML = newBody.innerHTML;
      if (newFooter && cartDrawerFooter) {
        cartDrawerFooter.replaceWith(newFooter);
        cartDrawerFooter = document.querySelector('[data-cart-drawer-footer]');
      }

      bindCartItemEvents(cartDrawer);
    } catch (e) {
      /* drawer refresh failed — cart add may still have succeeded */
    }

    return fetch('/cart.js').then((r) => (r.ok ? r.json() : null));
  }

  async function changeLineItem(key, quantity) {
    const response = await fetch(cartChangeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });

    if (!response.ok) throw new Error('Cart update failed');

    if (isCartPage) {
      window.location.reload();
      return null;
    }

    const cart = await refreshCartDrawer();
    if (cart) updateCartCount(cart.item_count);
    return cart;
  }

  function bindQuantityButtons(root = document) {
    root.querySelectorAll('[data-quantity-minus]:not([data-qty-bound])').forEach((btn) => {
      btn.dataset.qtyBound = 'true';
      btn.addEventListener('click', () => {
        const input = btn.parentElement.querySelector('input[type="number"]');
        if (!input) return;

        const min = parseInt(input.min, 10) || 0;
        const next = parseInt(input.value, 10) - 1;
        if (next >= min) {
          input.value = next;
          if (input.dataset.lineKey) changeLineItem(input.dataset.lineKey, next);
        }
      });
    });

    root.querySelectorAll('[data-quantity-plus]:not([data-qty-bound])').forEach((btn) => {
      btn.dataset.qtyBound = 'true';
      btn.addEventListener('click', () => {
        const input = btn.parentElement.querySelector('input[type="number"]');
        if (!input) return;
        const next = parseInt(input.value, 10) + 1;
        input.value = next;
        if (input.dataset.lineKey) changeLineItem(input.dataset.lineKey, next);
      });
    });
  }

  function bindCartItemEvents(root = document) {
    bindQuantityButtons(root);

    root.querySelectorAll('[data-cart-remove]:not([data-remove-bound])').forEach((btn) => {
      btn.dataset.removeBound = 'true';
      btn.addEventListener('click', async () => {
        const key = btn.dataset.lineKey;
        if (!key) return;
        btn.disabled = true;
        try {
          await changeLineItem(key, 0);
        } finally {
          btn.disabled = false;
        }
      });
    });
  }

  document.querySelectorAll('[data-cart-drawer-close]:not([data-close-bound])').forEach((btn) => {
    btn.dataset.closeBound = 'true';
    btn.addEventListener('click', closeCartDrawer);
  });

  document.querySelectorAll('[data-cart-toggle]:not([data-toggle-bound])').forEach((btn) => {
    btn.dataset.toggleBound = 'true';
    btn.addEventListener('click', openCartDrawer);
  });

  bindCartItemEvents(document);

  document.querySelectorAll('[data-variant-select]:not([data-variant-bound])').forEach((select) => {
    select.dataset.variantBound = 'true';
    const form = select.closest('form');
    const hiddenId = form?.querySelector('[data-variant-id]');

    select.addEventListener('change', () => {
      const variantId = select.value;
      if (hiddenId) hiddenId.value = variantId;
    });
  });

  document.querySelectorAll('[data-product-form]:not([data-form-bound])').forEach((form) => {
    form.dataset.formBound = 'true';
    const errorEl = form.querySelector('[data-cart-error]');
    const submitBtn = form.querySelector('[data-add-to-cart]');

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }

      const variantInput = form.querySelector('[name="id"]');
      if (!variantInput || !variantInput.value) {
        if (errorEl) {
          errorEl.textContent = 'Please select a product option.';
          errorEl.hidden = false;
        }
        return;
      }

      if (submitBtn) submitBtn.disabled = true;

      try {
        const formData = new FormData(form);

        const response = await fetch(cartAddUrl, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData,
        });

        const data = await response.json().catch(() => ({}));

        if (!response.ok) {
          const message = data.description || data.message || 'Could not add to cart. Please try again.';
          if (errorEl) {
            errorEl.textContent = message;
            errorEl.hidden = false;
          }
          return;
        }

        const cart = await refreshCartDrawer();
        if (cart) {
          updateCartCount(cart.item_count);
        } else {
          updateCartCount((parseInt(cartCountEls[0]?.textContent, 10) || 0) + parseInt(formData.get('quantity') || '1', 10));
        }

        openCartDrawer();
      } catch (error) {
        if (errorEl) {
          errorEl.textContent = 'Something went wrong. Redirecting to cart…';
          errorEl.hidden = false;
        }
        form.removeAttribute('data-form-bound');
        form.submit();
      } finally {
        if (submitBtn) submitBtn.disabled = false;
      }
    });
  });

  if (!document.body.dataset.escapeBound) {
    document.body.dataset.escapeBound = 'true';
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeCartDrawer();
    });
  }
}
